<template>
	<v-col class="history-bonus">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Histori Transfer Serial</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
			<div class="px-2">/</div>
			<div>Serial</div>
			<div class="px-2">/</div>
			<div>Histori Transfer Serial</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab @click="showSerialRegistration = true">Serial Registrasi</v-tab>
							<v-tab @click="showSerialRegistration = false">Serial Produk Binary</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerialRegistration">
					<SerialRegistration></SerialRegistration>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="!showSerialRegistration">
					<SerialProdukBinary></SerialProdukBinary>
				</div>
			</v-scroll-x-transition>
		</div>
	</v-col>
</template>

<script>
import SerialRegistration from './SerialRegistration';
import SerialProdukBinary from './SerialProdukBinary';

export default {
	components: {
		SerialRegistration, SerialProdukBinary
	},
	data() {
		return {
			showSerialRegistration: true,
		}
	},
	methods: {
	},
	created(){
		this.$store.dispatch('setPageTitle', `Histori Transfer Serial`)
	}
};
</script>

